import { useForm } from "react-hook-form";
import { useState, useEffect, useMemo } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerPlantillas,
  eliminarPlantilla,
  actualizarPlantilla,
  almacenarPlantilla,
  obtenerPlantillasPorTipo,
} from "../../redux/plantillasSlice";
import { obtenerTiposPlantillas } from "../../redux/genericosSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import SummerNoteReactV from "../../Components/SummerNoteReactV";
import ReactSelectGroup from "../../Components/ReactSelectGroup";
import Required from "../../Components/Required";
import { OrderTable } from "../../Components/OrderTable";
import useSubmit from "../../Hooks/useSubmit";
import { getAdminTemplatePage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaListaPlantillas";
function ListaPlantillas(props) {
  const { validation } = useValidation();
  const { locale } = useLocale();
  const [adminTemplatePage, setAdminTemplatePage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedNombres, setTranslatedNombres] = useState({});
  const [translatedTipos, setTranslatedTipos] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);
  const [modalState, changeModalState] = useState(false);
  const [removeState, changeRemoveState] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [isCreating, setCreating] = useState(false);
  const [registerSelected = [], selectReg] = useState();
  const [variables = [], setVariables] = useState([]);
  const [valor, setValor] = useState(undefined);
  const [clickPosition, setClickPosition] = useState({ start: 0, end: 0 });

  const [tituloModal, setTituloModal] = useState("Agregar plantilla");
  const { width } = WindowDimension();

  const { submitAction } = useSubmit();
  const dispatch = useDispatch();

  const { plantillas } = useSelector((state) => state.plantillas);
  const { tiposPlantillas } = useSelector((state) => state.genericos);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      esTextoPlano: false,
      plantillId: 0,
      plantillaNombre: "",
      asunto: "",
      cuerpo: "",
      tipoPlantillaId: undefined,
    },
  });
  const tipoPlantillaId = watch("tipoPlantillaId");
  const esTextoPlano = watch("esTextoPlano");

  const columns = useMemo(() => {
    const templatesTable = adminTemplatePage?.templates_table ?? [];
    return [
      { label: templatesTable[0]?.label || 'Código', accessor: 'plantillaId', sortable: true },
      { 
        label: templatesTable[1]?.label || 'Nombre', 
        accessor: 'plantillaNombre', 
        sortable: true,
        render: (item) => (
          <td>{translatedNombres[item.plantillaNombre] || item.plantillaNombre}</td>
        ),
      },
      { 
        label: templatesTable[2]?.label || 'Tipo', 
        accessor: 'tipo', 
        sortable: true,
        render: (item) => (
          <td>{translatedTipos[item.tipo] || item.tipo}</td>
        ),
      },
      { label: templatesTable[3]?.label || 'Acción', accessor: 'action', sortable: false },
    ];
  }, [adminTemplatePage, translatedNombres, translatedTipos]);

  const showModalEdit = (reg) => {
    reset(reg);
    setEditing(true);
    setCreating(false);
    selectReg(reg);

    setTituloModal(adminTemplatePage?.subtitleTR || "Editar plantilla");
    changeModalState(true);
  };

  const closeModalEdit = () => {
    reset({
      plantillId: 0,
      plantillaNombre: "",
      asunto: "",
      cuerpo: "",
      tipoPlantillaId: undefined,
      esTextoPlano: false,
    });
    changeModalState(false);
  };

  const showRemoveModalEdit = (reg) => {
    selectReg(reg);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    selectReg();
    changeRemoveState(false);
  };

  const cargarPlantillas = () => {
    dispatch(obtenerPlantillas());
    dispatch(obtenerTiposPlantillas());
  };

  const cargarPlantillasPorTipo = (e) => {
    dispatch(obtenerPlantillasPorTipo(e.target.value));
  };

  const eliminar = async () => {
    submitAction(eliminarPlantilla, registerSelected.plantillaId, () => {
      closeRemoveModalEdit();
      cargarPlantillas();
    });
  };

  const actualizar = async (data) => {
    setCreating(false);
    submitAction(
      data.plantillaId > 0 ? actualizarPlantilla : almacenarPlantilla,
      data,
      () => {
        closeModalEdit();
        cargarPlantillas();
      }
    );
  };

  useEffect(() => {
    cargarPlantillas();
  }, [dispatch]);

  useEffect(() => {
    let a = tiposPlantillas?.find((x) => x.tipoPlantillaId == tipoPlantillaId);
    if (a) {
      setVariables(JSON.parse(a.variables));
    }
  }, [tipoPlantillaId]);

  useEffect(() => {
    let cuerpo = getValues("cuerpo");
    if (esTextoPlano) {
      var plainText = cuerpo
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/&nbsp;|<br>/g, " ");
      setValue("cuerpo", plainText);
    }
  }, [esTextoPlano]);

  const agregarParametroClick = (val) => {
    let text = getValues("cuerpo");
    let a =
      text.substring(0, clickPosition.start) +
      `{{${val}}}` +
      text.substring(clickPosition.end);
    setValue("cuerpo", a);
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminTemplatePage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminTemplatePage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminTemplatePage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los campos "Nombre" y "Tipo" cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasPlantillas = plantillas && Array.isArray(plantillas) && plantillas.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasPlantillas) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const nombreTranslations = {};
      const tipoTranslations = {};

      // Traducir solo los campos solicitados
      const translationPromises = plantillas.map(async (item) => {
        if (item.plantillaNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.plantillaNombre, locale);
          nombreTranslations[item.plantillaNombre] = translated;
        }
        if (item.tipo) {
          const translated = await _translateValue(SCREEN_NAME, item.tipo, locale);
          tipoTranslations[item.tipo] = translated;
        }
      });
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedNombres(nombreTranslations);
      setTranslatedTipos(tipoTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [plantillas, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <main className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Input style={{ width: 200, height: 40 }} active />
          <Skeleton.Button style={{ width: 100, height: 40 }} active />
        </div>
        <div className="container-fluid">
          <Skeleton active paragraph={{ rows: 6 }} />
          <Skeleton.Input style={{ width: '100%', height: 200 }} active />
        </div>
      </main>
    );
  }

  return (
    <main className="main-admin">
      <div className="main-admin-bar">
        <button
          className="main-admin-button"
          onClick={() => {
            changeModalState(true);
            setTituloModal(adminTemplatePage?.subtitleO || "Nueva plantilla");
            reset();
            setEditing(false);
            setCreating(true);
          }}
        >
          +
        </button>
        <h2>{adminTemplatePage?.title || "Plantillas de notificaciones"}</h2>
        <div className="select-filter-section  ml-auto">
          <label hidden>Filtrar por tipo</label>
          <select onChange={cargarPlantillasPorTipo}>
            <option value="0">{adminTemplatePage?.select_option || "Todos los tipos"}</option>
            {tiposPlantillas?.map((a, i) => {
              return (
                <option key={i} value={a.tipoPlantillaId}>
                  {a.tipoPlantillaNombre}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <Modal
        estado={modalState}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "medium"}`}
        buttonGroup={
          <>
            <button className="button-text" onClick={handleSubmit(actualizar)}>
              {adminTemplatePage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div>
            <div className="form-group">
              <label>{adminTemplatePage?.templates_name || "Nombre de la plantilla"}</label>
              <Required />
              <input
                className="form-control"
                id="titleEdit"
                type="text"
                {...register("plantillaNombre", {
                  required: validation?.required_field || "Campo requerido",
                })}
                name="plantillaNombre"
              ></input>
              {errors.plantillaNombre && (
                <p className="error">{errors.plantillaNombre.message}</p>
              )}
            </div>
          </div>
          <div className="form-group">
            <label>{adminTemplatePage?.templates_type || "Tipo"}</label>
            <Required />
            <select
              className="form-control"
              {...register("tipoPlantillaId", { required: validation?.required_field || "Campo requerido" })}
              name="tipoPlantillaId"
            >
              <option value={undefined}>{adminTemplatePage?.select_optionA || "Seleccione"}</option>
              {tiposPlantillas?.map((a, i) => {
                return (
                  <option key={i} value={a.tipoPlantillaId}>
                    {a.tipoPlantillaNombre}
                  </option>
                );
              })}
            </select>
            {errors.tipo && <p className="error">{errors.tipo.message}</p>}
          </div>
          <div className="form-group">
            <label>{adminTemplatePage?.theme || "Asunto"}</label>
            <Required />
            <input
              className="form-control"
              type="text"
              {...register("asunto", { required: validation?.required_field || "Campo requerido" })}
              name="asunto"
            ></input>
            {errors.asunto && <p className="error">{errors.asunto.message}</p>}
          </div>
          <div className="flex-modal-group">
            {/* TODO: ME QUEDE POR AQUI */}
            <div className="flex-check ">
              <input
                checked={esTextoPlano}
                onInput={(e) => {
                  setValue("esTextoPlano", e.target.checked);
                }}
                ref={register}
                {...register("esTextoPlano")}
                type="checkbox"
              />
              <label>{adminTemplatePage?.savetext || "Guardar texto plano"}</label>
            </div>
            {esTextoPlano && (
              <div className="flex-check ">
                <ReactSelectGroup
                  lista={variables}
                  value={valor}
                  handleChange={agregarParametroClick}
                />
              </div>
            )}
          </div>

          {esTextoPlano ? (
            <div className="form-group">
              <label>{adminTemplatePage?.bodytext || "Cuerpo"}</label>
              <Required />
              <textarea
                className="form-control"
                {...register("cuerpo", {
                  required: validation?.required_field || "Campo requerido",
                  onBlur: (e) => {
                    setClickPosition({
                      start: e.target.selectionStart,
                      end: e.target.selectionEnd,
                    });
                  },
                })}
              ></textarea>
              {errors.cuerpo && (
                <p className="error">{errors.cuerpo.message}</p>
              )}
            </div>
          ) : (
            <div className="editorContainerModal form-group">
              <label>{adminTemplatePage?.bodytext || "Cuerpo de texto"}</label>
              <Required />
              <div className="divEditorModal">
                <SummerNoteReactV
                  control={control}
                  name="cuerpo"
                  rules={{ required: validation?.required_field || "Campo requerido" }}
                  isEditing={isEditing}
                  isCreating={isCreating}
                  val={registerSelected.plantillaId}
                  lista={variables}
                />
                {errors.cuerpo && (
                  <p className="error">{errors.cuerpo.message}</p>
                )}
              </div>
            </div>
          )}
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title={adminTemplatePage?.subtitleT || "Eliminar plantillla"}
        message={adminTemplatePage?.question || "¿Seguro que desea eliminar el siguiente registro?"}
        item={registerSelected.nombre}
        icon={null}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              {adminTemplatePage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              {adminTemplatePage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />

      <div className="table-container">
        {plantillas.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={plantillas}
              clase="table-adm"
              actions={[
                {
                  icon: "",
                  clase: "text-primary",
                  event: (item) => showModalEdit(item),
                },
                {
                  icon: "",
                  clase: "delete",
                  event: (item) => showRemoveModalEdit(item),
                },
              ]}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>
    </main>
  );
}

export default ListaPlantillas;
